<ag-grid-angular #agGrid class="ag-theme-sg-bootstrap-condensed" [gridOptions]="gridOptions!"
[defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="disposalsItems" (gridReady)="onGridReady($event)">
</ag-grid-angular>
